import { __exports as ITF14 } from "./index199.js";
import { __require as requireITF } from "./index172.js";
var hasRequiredITF14;
function requireITF14() {
  if (hasRequiredITF14) return ITF14;
  hasRequiredITF14 = 1;
  Object.defineProperty(ITF14, "__esModule", {
    value: true
  });
  var _createClass = /* @__PURE__ */ (function() {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  })();
  var _ITF2 = requireITF();
  var _ITF3 = _interopRequireDefault(_ITF2);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var checksum = function checksum2(data) {
    var res = data.substr(0, 13).split("").map(function(num) {
      return parseInt(num, 10);
    }).reduce(function(sum, n, idx) {
      return sum + n * (3 - idx % 2 * 2);
    }, 0);
    return Math.ceil(res / 10) * 10 - res;
  };
  var ITF14$1 = (function(_ITF) {
    _inherits(ITF142, _ITF);
    function ITF142(data, options) {
      _classCallCheck(this, ITF142);
      if (data.search(/^[0-9]{13}$/) !== -1) {
        data += checksum(data);
      }
      return _possibleConstructorReturn(this, (ITF142.__proto__ || Object.getPrototypeOf(ITF142)).call(this, data, options));
    }
    _createClass(ITF142, [{
      key: "valid",
      value: function valid() {
        return this.data.search(/^[0-9]{14}$/) !== -1 && +this.data[13] === checksum(this.data);
      }
    }]);
    return ITF142;
  })(_ITF3.default);
  ITF14.default = ITF14$1;
  return ITF14;
}
export {
  requireITF14 as __require
};
//# sourceMappingURL=index173.js.map
